import React from "react";
import CloseModalButton from "../../Buttons/CloseModalButton";

const index = ({ setIsFilterOpen, children }) => {
    return (
        <div
            className="fixed top-0 left-0 block md:hidden h-screen w-screen bg-white transition-transform duration-500 translate-y-0 animate-slide-up"
            style={{ zIndex: 150 }}
        >
            <div className="absolute top-0 right-0 p-2" style={{ zIndex: 150 }}>
                <CloseModalButton setIsModalOpen={setIsFilterOpen} />
            </div>
            <div className="h-full overflow-y-scroll no-scrollbar pt-5 px-2">
                {children}
            </div>
        </div>
    );
};

export default index;
